<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <footer :class="{hasContent}">
    <AppTimer v-if="timeout" :key="timerKey" :timeout :callback="onTimeout" />
    <slot v-else />
  </footer>
</template>

<script setup>
import AppTimer from "@/components/App/Timer";
defineProps(["hasContent", "timeout", "timerKey", "onTimeout"]);
</script>

<style scoped>
footer {
  min-height: 1rem;
}
footer.hasContent {
  flex: none; /* never squeezed: in a fixed-height card (#profile) the body scrolls instead */
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* the content to the footer: --dialog-footer-gap, 32px unless the dialog's footerGap says
     otherwise (Seán, 2026-10-23); Main's 0.5rem below the content, and this */
  padding-top: calc(var(--dialog-footer-gap, 32px) - 0.5rem);
  padding-bottom: 28px; /* Seán's spec for #sign-in (2026-10-22), every dialog's since */
}
/* a short laptop window (a browser bar, 640px): the standard gap back to its old 16px, so the
   content keeps its room (#profile's Settings scrolled, localhost round 34, 2026-10-23); a
   dialog's own footerGap still applies. With a mouse only: a phone is as short, and keeps the
   32px (Seán, iOS, 2026-10-23); not by orientation, as a laptop's window can be narrow too */
@media (max-height: 700px) and (hover: hover) {
  footer.hasContent {
    padding-top: calc(var(--dialog-footer-gap, 16px) - 0.5rem);
  }
}
footer :deep(button) {
  min-height: 44px;
}
/* the call to action (Seán, 2026-10-23): one weight up (normal to semibold), the dark brand
   green (white on it 3.7:1; on the brand green 2.1:1); hover darkens it as before (brightness) */
footer :deep(button.outstanding:not([disabled])),
footer :deep(button.outstanding:not([disabled]):hover) {
  font-weight: 600;
  background-color: var(--brand-dark-color);
}
/* disabled: still plainly a button, its label readable (#666 on #c8c8c8) */
footer :deep(button[disabled]) {
  color: #666;
  background-color: #c8c8c8;
  box-shadow: none;
}
footer.hasContent > * {
  width: 100%;
  flex: 0 1 auto;
}
</style>
